import * as React from "react";
import { PropTypes } from "components/controls";
import { formatDate } from "common/utils/FmtDate";
import Alert from "common/components/controls/Alert";
import PU from "common/utils/PrestupyUtils";

export interface StavProps {
    stav: number;
    terminOdstupneho?: Date;
}


class Stav extends React.PureComponent<StavProps>{

    render() {

        const { stav, terminOdstupneho } = this.props;
        let content: string;
        let color: PropTypes.Color = 'warning';
        switch (stav) {

            case PU.Stav_PotvrzeniIC:
                content = 'Čeká se, až individuelní člen potvrdí přestup.';
                break;
            case PU.Stav_ZaplaceniPopl:
                content = 'Čeká se na zaplacení správního poplatku za podání přestupu.';
                break;
            case PU.Stav_ZpracovaniPrestupu:
                content = 'Čeká se na zpracování přestupu sekretariátem ČSTS.';
                break;
            case PU.Stav_PotvrzeniOdst:
                content = `Čeká se, až bývalý kolektivní člen v termínu do ${formatDate(terminOdstupneho)} uplatní nárok na odstupné.`;
                break;
            case PU.Stav_ZaplaceniOdst:
                content = `Čeká se, až bývalý kolektivní člen potvrdí zaplacení odstupného.`;
                break;
            case PU.Stav_Ukonceno:
                color = "success";
                content = 'Přestup byl dokončen.';
                break;
            case PU.Stav_ZamitnutoIC:
                color = "danger";
                content = 'Přestup byl zamítnut IČ.';
                break;
            case PU.Stav_Stornovan:
                color = "danger";
                content = 'Přestup byl stornován.';
                break;
        }

        return <Alert color={color}>{content}</Alert>;
    }
}


export default Stav;